<template>
    <div class="header">
        <div class="icon">
            <img src="@/assets/images/KINGVIL.png" height="60" alt="">
<!--            <div class="icon-text">长沙中南经纬环境研究院有限公司</div>-->
<!--            <img style="margin-left: 10px;object-fit: cover" src="@/assets/images/img_1.png" alt="" height="60">-->
        </div>

        <div class="menu">
            <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect"
                    background-color="transparent"
                    text-color="#fff"
                    active-text-color="white"
            >
                <el-menu-item index="1">
                    <template #title>首页</template>
                </el-menu-item>
                <el-sub-menu index="2">
                    <template #title>解决方案</template>
                    <el-menu-item index="2-1">item one</el-menu-item>
                </el-sub-menu>
                <el-sub-menu index="3">
                    <template #title>典型案例</template>
                    <el-menu-item index="3-1">item one</el-menu-item>
                </el-sub-menu>
                <el-sub-menu index="4">
                    <template #title>数据服务</template>
                    <el-menu-item index="4-1">item one</el-menu-item>
                </el-sub-menu>
            </el-menu>
        </div>

        <div class="login" v-if="$store.state.isLogin === false">
            <el-button
                    color="#626aef"
                    @click="login"
            >登录</el-button>
            <el-button type="primary">
                注册
            </el-button>
        </div>
        <div class="login" v-if="$store.state.isLogin !== false">
            <span>欢迎您， </span>
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ $store.state.username }}
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item command="a">管理员中心</el-dropdown-item>
                        <el-dropdown-item command="b">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
<!--            <div @click="openPop" class="username">{{ $store.state.username }}</div>-->
        </div>
    </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      popShow: false
    }
  },
  methods: {
    handleSelect(item) {
      if (item === '1') {
        this.$router.push('/')
      }
    },
    login() {
      this.$router.push('/login')
    },
    openPop() {
      this.popShow = !this.popShow
    },
    handleCommand(command) {
      if (command === 'a') {
        this.$router.push('/center')
      }
      if (command === 'b') {
        this.$router.push('/')
        this.$store.commit('changeLoginStat', false)
        localStorage.clear();
        sessionStorage.removeItem('token')
      }
    }
  }
}
</script>

<style scoped lang="less">

.header {
    width: 100%;
    max-height: 85px;
    background-color: black;
    padding: 12px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
        padding: 0 20px;
        height: 60px;
        display: flex;
        align-items: center;
      .icon-text {
        background-image: linear-gradient(to bottom, rgb(153,104,41), rgb(240,230,148), rgb(153,104,41));
        -webkit-background-clip: text;
        color: transparent;
        font-size: 35px;
      }
    }

    .menu {
        font-size: 20px !important;
        width: 600px;
         /deep/ .el-sub-menu__title {

            font-size: 20px !important;
        }
        .el-menu {
            font-size: 20px !important;
            background-color: transparent;
            color: white !important;
            border-bottom: 0 !important;
        }
        .el-menu-item {
            font-size: 20px;
            border-bottom: 0 !important;
        }
        .el-sub-menu {
            font-size: 26px;
            color: white !important;
            border-bottom: 0 !important;
            .el-sub-menu__title {
                border-bottom: 0 !important;
                font-size: 26px !important;
            }
        }
        flex-direction: column;
    }
    .login {
        padding: 0 50px;
        display: flex;
        flex-direction: row;
        align-items: baseline;
      font-size: 16px;
        color: white;
        .username {
          display: inline-block;
        }
        .el-dropdown-link {
          color: white;
          font-size: 18px !important;
          cursor: pointer;
        }
    }
}

.el-popper {
    background: transparent !important;
    border: 1px solid transparent !important;
    .is-light {
        border-color: transparent;
    }
    .el-menu--horizontal {
        .el-menu--popup {
            background-color: #79bbff !important;
            .el-menu-item {
                border-color: transparent;
                background-color: #79bbff !important;
            }
        }
        .el-menu--popup-bottom-start{
            .el-sub-menu{
                .el-tooltip__trigger{
                    background-color: #79bbff !important;
                }
            }
        }
    }
}
</style>